import React from "react";
import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <main data-testid="not-found-page" className="min-h-screen flex items-center justify-center px-4 pt-24 pb-16 bg-[#f7faf8]">
      <Seo
        path="/404"
        title="Page not found — WorkPay"
        description="The page you were looking for could not be found. Return to WorkPay to collect project payments with clarity."
        noindex
      />
      <div className="max-w-lg text-center">
        <p className="font-display text-[120px] leading-none font-extrabold text-[#091630]">
          4<span className="text-[#21c55e]">0</span>4
        </p>
        <h1 className="font-display text-3xl font-extrabold text-[#091630] mt-4">This page took a wrong turn.</h1>
        <p className="text-slate-500 mt-3 text-base leading-relaxed">
          The page you're looking for doesn't exist or may have moved. Let's get you back to safe ground.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            data-testid="notfound-home-link"
            className="inline-flex items-center justify-center gap-2 bg-[#21c55e] text-[#091630] font-bold py-3 px-6 rounded-full hover:bg-[#16a34a] hover:text-white transition-colors"
          >
            <Home className="h-5 w-5" /> Back to home
          </Link>
          <Link
            to="/pricing"
            data-testid="notfound-pricing-link"
            className="inline-flex items-center justify-center gap-2 bg-white text-[#091630] font-semibold py-3 px-6 rounded-full border border-slate-200 hover:border-slate-300 transition-colors"
          >
            <ArrowLeft className="h-5 w-5 text-[#16a34a]" /> See pricing
          </Link>
        </div>
      </div>
    </main>
  );
}
